import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue'
import store from '@/store'
import SearchBar from '../../components/Searchbar/SearchBar.vue'
import Promotion from '../../components/Promotion/Promotion.vue'
import SocialPacket from '../../components/Socialpacket/SocialPacket.vue'
import Partners from '../../components/Partnersprivil/PartnersPrivil.vue'
import Popup from '../../components/Popup/Popup.vue'
import FeedBack from '../../components/Feedback/FeedBack.vue'
import CardNotFound from '@/components/CardNotFound.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const isOpen = ref(false)
const showContent = ref(false)
const cardsProm: any = ref(0)
const cardsSocial: any = ref(0)
const initReq = ref(false)

const openPopup = (who) => {
  isOpen.value = true
}
const cardBusy = computed(() => store.getters.isCardBusy)

const partnerCards = computed(() => {
  let data = store.getters.getCardSortItems

  if (
    data !== undefined &&
    data.types !== undefined &&
    data.types[2] !== undefined
  ) {
    if (data.types[2].length > 10) {
      data.types[2].length = 10
    }
    return data.types[2]
  }

  return []
})

const cardLenghts = computed(() => {
  if (
    cardsProm.value <= 0 &&
    cardsSocial.value <= 0 &&
    partnerCards.value.length <= 0
  ) {
    return true
  }
  return false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_Transition, {
      name: "popup",
      onAfterEnter: _cache[2] || (_cache[2] = ($event: any) => (showContent.value = true))
    }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createBlock(Popup, {
              key: 0,
              open: isOpen.value,
              showContent: showContent.value,
              onPopupClose: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false)),
              onCloseContent: _cache[1] || (_cache[1] = ($event: any) => (showContent.value = false))
            }, null, 8, ["open", "showContent"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(SearchBar, {
      isHomePage: true,
      showLocation: true,
      onInitRequest: _cache[3] || (_cache[3] = (e) => (initReq.value = e))
    }),
    _createVNode(Promotion, {
      onPromotionClickCard: _cache[4] || (_cache[4] = ($event: any) => (openPopup('openpopup promotion'))),
      onPromotionCardsLength: _cache[5] || (_cache[5] = (e) => (cardsProm.value = e))
    }),
    _createVNode(SocialPacket, {
      onSocialClickCard: _cache[6] || (_cache[6] = ($event: any) => (openPopup('openpopup Social'))),
      onSocialCardsLength: _cache[7] || (_cache[7] = (e) => (cardsSocial.value = e))
    }),
    (initReq.value && _unref(cardLenghts) && !_unref(cardBusy))
      ? (_openBlock(), _createBlock(CardNotFound, { key: 0 }))
      : _createCommentVNode("", true),
    (initReq.value)
      ? (_openBlock(), _createBlock(Partners, {
          key: 1,
          onPartnersClickCard: _cache[8] || (_cache[8] = ($event: any) => (openPopup('openpopup partners'))),
          showLink: true,
          showTitle: true,
          partnerCards: _unref(partnerCards)
        }, null, 8, ["partnerCards"]))
      : _createCommentVNode("", true),
    (initReq.value && !_unref(cardLenghts))
      ? (_openBlock(), _createBlock(FeedBack, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})